import clsx from 'clsx'
import { forwardRef, ReactNode, useContext } from 'react'
import { TabsContext } from './TabsContext'
import styles from './TabsPanel.module.scss'

export interface TabsPanelProps {
  id: string
  children: ReactNode
  className?: string
}

export const TabsPanel = forwardRef<HTMLDivElement, TabsPanelProps>(
  ({ id, children, className }, ref) => {
    const { value, wrapperId, direction, size } = useContext(TabsContext)
    const isSelected = value === id

    return (
      <div
        className={clsx(
          styles.tabPanel,
          styles[direction],
          styles[size],
          {
            [styles.selected]: isSelected,
          },
          className,
        )}
        role="tabpanel"
        tabIndex={0}
        ref={ref}
        aria-labelledby={`tab-${wrapperId}-${id}`}
        hidden={!isSelected}
      >
        {children}
      </div>
    )
  },
)
